'use client';
import { type ReactNode } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Button } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';
import { ErrorLayout } from '../ui';

const Bold = (chunks: ReactNode) => <Text fontWeight="semiBold">{chunks}</Text>;
const EmailLink = (chunks: ReactNode) => {
  return (
    <Link href="mailto:hello@mentimeter.com?subject=Server error on voting web">
      {chunks}
    </Link>
  );
};
const FiveHundred = () => {
  const translate = useTranslations('participating.error_page');

  return (
    <ErrorLayout>
      <Box alignItems="center">
        <Text
          fontFamily="heading"
          lineHeight="heading"
          fontWeight="semiBold"
          color="text"
          fontSize={5}
          as="h1"
          textAlign="center"
        >
          {translate('heading_text')}
        </Text>
        <Text my={2}>
          {translate.rich('try_again_message', {
            Bold,
          })}
        </Text>
        <Box alignItems="center">
          <Button
            size="large"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
          >
            {translate('try_again_button')}
          </Button>
        </Box>
        <Text my={2}>
          {translate.rich('contact_us_if_problem_persists_message', {
            EmailLink,
          })}
        </Text>
        <Text as="p" fontStyle="italic" textAlign="center">
          {translate('signoff_message')}
        </Text>
      </Box>
    </ErrorLayout>
  );
};

export default FiveHundred;
